import { Box, Button, Typography } from '@mui/material';
import { insuranceActions, insuranceSelector } from '../../../model';
import { useDispatch, useSelector } from 'react-redux';
import { useNotifications } from 'modules/notification';
import { getInsuranceTaskInput } from '../../../lib';
import { useLazyQuery, useMutation } from '@apollo/client';
import { UPSERT_TASK } from 'queries/common';
import { Q_DOCS } from '../../../api';
import { documentsByKey } from 'pages/Prequal/constants';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useStepperState } from 'modules/vendorOpportunity/insurance/hooks/useStepperState';
import { coverageStatusConfig } from 'modules/vendorOpportunity/insurance/constants';
import { CoverageStatusLabels } from 'modules/vendorOpportunity/insurance/types';
import FileUploadModal from 'pages/VendorOpportunity/FileUploadModal';
import { IS_DEVELOPMENT } from 'constants/common';

export const NoCertificate = () => {
  const dispatch = useDispatch();

  const vo = useSelector((state: any) => state.vo);
  const account = useSelector((state: any) => state.account);
  const creditApp = useSelector((state: any) => state.creditApp);
  const userProfile = useSelector((state: any) => state.userProfile);
  const insuranceBroker = useSelector(insuranceSelector.insuranceBroker)!;
  const selectedSubmission = useSelector(insuranceSelector.selectedSubmission)!;
  const selectedFinanceProgram = useSelector(insuranceSelector.selectedFinanceProgram)!;

  const insuranceVerificationTask = useSelector(insuranceSelector.insuranceVerificationTask)!;

  const { showNotification } = useNotifications();
  const { stepperCompleteVerifyCoverage } = useStepperState();

  const [getDocument] = useLazyQuery(Q_DOCS, {
    onCompleted(docResponse) {
      dispatch(insuranceActions.setInsuranceCertificate(docResponse.documents[0]));
      stepperCompleteVerifyCoverage();
      dispatch(insuranceActions.setCoverageStatusConfig(coverageStatusConfig[CoverageStatusLabels.InsuredVerified]));
      showNotification('Insurance Certificate Uploaded Successfully!');
    },
  });
  const [upsertTask, { loading: isTaskCreationLoading }] = useMutation(UPSERT_TASK);

  const handleVerifyCoverage = async () => {
    try {
      const taskInput = getInsuranceTaskInput(
        vo.vendorOpportunityId,
        creditApp.id,
        selectedFinanceProgram.financeProgramId,
        userProfile,
        account,
        selectedSubmission,
        insuranceBroker
      );
      const upsertResult = await upsertTask({ variables: { input: taskInput } });
      dispatch(
        insuranceActions.setInsuranceVerificationTask({ ...taskInput, taskId: upsertResult?.data?.upsertTask?.id })
      );
      showNotification('Task successfully created!');
    } catch (error) {
      showNotification('Error', { type: 'error' });
    }
  };

  /*   const handleSaveFile = async (file: File) => {
    try {
      const { data } = await uploadFile({
        variables: {
          input: {
            vendorOpportunityId: vo.vendorOpportunityId,
            dynamicsVendorOpportunityId: vo.dynamicsVendorOpportunityId,
            source: "will_be_changed_by_server",
            docType: documentsByKey.insurance_certificate.value,
            createdBy: "will_be_changed_by_server",
            docName: "will_be_changed_by_server",
            dealerAccess: true,
            lenderAccess: false,
            creditSubId: selectedSubmission.creditSubId,
          },
          file,
        },
      });
      await getDocument({ variables: { docId: data.upsertDocument.document } });
    } catch (error) {
      showNotification("Error", { type: "error" });
    }
  }; */

  const handleOnFileUploaded = async ({ document, success }: { document: string; success: boolean }) => {
    if (document && success) {
      await getDocument({ variables: { docId: document } });
    } else {
      showNotification('Error', { type: 'error' });
    }
  };

  const handleGoToTaskPage = () => {
    const link = `https://app.${IS_DEVELOPMENT ? 'dev.' : ''}trnsact.com/task-page?taskId=${
      insuranceVerificationTask.taskId
    }&lenderProfileDynamicsId=${selectedSubmission.lenderProfileId}&vendorGUID=${account.dynamicsAccountId}`;
    window.open(link, '_blank');
  };

  return (
    <>
      {insuranceVerificationTask ? (
        <Box display="flex" justifyContent="space-between">
          <Box display="flex">
            <CheckCircleOutlineIcon color="primary" />
            <Typography mb={2} ml={0.5} component="p" variant="body1">
              You have sent the request to Insurance Agent
            </Typography>
          </Box>
          <Box>
            <Button size="small" color="primary" onClick={() => {}} disabled>
              Open task
            </Button>
            <Button
              size="small"
              color="primary"
              startIcon={<OpenInNewIcon fontSize="small" />}
              onClick={handleGoToTaskPage}
              sx={{ ml: 1 }}
            >
              Open task page
            </Button>
          </Box>
        </Box>
      ) : (
        selectedSubmission &&
        selectedFinanceProgram && (
          <Button
            loading={isTaskCreationLoading}
            size="small"
            color="primary"
            variant="contained"
            onClick={handleVerifyCoverage}
            sx={{ marginRight: 1 }}
          >
            Verify Coverage
          </Button>
        )
      )}

      <FileUploadModal
        vo={vo}
        vp={account.vendorProfile}
        equipmentUpload={false}
        buttonDescription={() => 'Upload Certificate of Insurance'}
        creditSubmissionId={selectedSubmission?.creditSubId}
        predefinedFileType={documentsByKey.insurance_certificate.value}
        relatedTo="submission"
        onFileUploaded={handleOnFileUploaded}
      />
    </>
  );
};
